import { mapState } from 'pinia';
import stores from 'store/modules';

export default {
    computed: {
        ...mapState(stores.User, ['loadingMain', 'user']),
    },

    watch: {
        async isLoadingEcho(status) {
            if (status) return;

            this.initUserEcho();
        },
    },

    methods: {
        initIntegrationsEcho() {
            if (!this.user?.id) return;
            if (!this.$echo) return;

            this.resetIntegrationsEcho();

            this.$echo
                .private(`user.${this.user.id}`)
                .listen('.integration.connected', this.echoIntegrationConnected)
                .listen('.integration.disconnected', this.echoIntegrationDisconnected)
                .listen('.integration.list.sync.finished', this.showToastHubspotListImported)
                .listen('.integration.teams.sync.finished', this.teamsSyncFinish)
                .listen('.integration.users.refreshed', this.refreshUserIntegration);
        },

        resetIntegrationsEcho() {
            if (!this.user?.id) return;
            if (!this.$echo) return;

            this.$echo
                .private(`user.${this.user.id}`)
                .stopListening('.integration.connected')
                .stopListening('.integration.disconnected')
                .stopListening('.integration.list.sync.finished')
                .stopListening('.integration.teams.sync.finished')
                .stopListening('.integration.users.refreshed');
        },

        initUserEcho() {
            if (!this.user?.id) return;
            if (!this.$echo) return;

            this.resetUserEcho();

            this.$echo
                .private(`user.${this.user.id}`)
                .listen('.auth.logout', this.echoAuthLogout)
                .listen('.importing.updated', this.echoImportUpdated)
                .listen('.message.popper', this.echoMessagePopper)
                .listen('.conversation.read', this.echoConversationRead)
                .listen('.conversation.unread', this.echoConversationUnread)
                .listen('.user.toggle_record_automatically', this.echoRecordAutomatically)
                .listen('.user.toggle_ring_everywhere', this.echoRingEverywhere)
                .listen('.attachment.video.converted', this.echoVideoConverted);
        },

        resetUserEcho(id) {
            if (!this.user?.id) return;
            if (!this.$echo) return;

            this.$echo
                .private(`user.${this.user.id}`)
                .stopListening('.auth.logout')
                .stopListening('.importing.updated')
                .stopListening('.message.popper')
                .stopListening('.conversation.read')
                .stopListening('.conversation.unread')
                .stopListening('.user.toggle_record_automatically')
                .stopListening('.user.toggle_ring_everywhere')
                .stopListening('.attachment.video.converted');
        },

        echoVideoConverted() {
            this.$store.dispatch('videoWasConverted', true);
            this.$store.dispatch('getAttachmentsList');
            this.$store.dispatch('showToast', {
                type: 'success',
                message: 'Video is ready.',
            });
        },

        echoAuthLogout() {
            this.$store.dispatch('loggedOut');
        },

        echoImportUpdated(e) {
            this.$store.dispatch('contactImportUpdated', e);
        },

        echoIntegrationConnected(e) {
            this.$store.dispatch('integrationConnected', e);
            this.$store.dispatch('getIntegrations');
        },

        echoIntegrationDisconnected(e) {
            this.$store.dispatch('integrationDisconnected', e);
        },

        echoRecordAutomatically(e) {
            this.$store.dispatch('recordAutomaticallyFromSocket', e.isRecordAutomatically);
        },

        echoRingEverywhere(e) {
            this.$store.dispatch('ringEverywhereFromSocket', e.isRingEverywhere);
        },

        echoVoiceTokenPrepared(e) {
            console.log('echoVoiceTokenPrepared', e);
        },

        showToastHubspotListImported(e) {
            this.$store.dispatch('showToast', {
                type: 'success',
                message: `Your HubSpot list ${e.list.name} has been imported!`,
                position: 1.5,
            });
        },

        teamsSyncFinish(e) {
            this.$store.dispatch('showToast', {
                type: 'success',
                message: `Your HubSpot Contact ${e.organization_name} has been refreshed!`,
            });
        },

        async refreshUserIntegration(e) {
            if (e.integration_user.integration.key !== 'hubspot') return;

            await this.$store.dispatch('getOrganizationMembers');
            await this.$store.dispatch('getIntegrationUsers', {
                integration: e.integration_user.integration.key,
            });
            await this.$store.dispatch('userIntegrationLoaded');

            await this.$store.dispatch('showToast', {
                type: 'success',
                message: 'User mapping successfully refreshed.',
            });
        },
    },
};
